import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormField, Input } from '@/shared/components';
import type { WorkspaceCreateValues } from './workspaceCreateModel';

export function WorkspaceInitialAdminFields({
  form,
}: {
  form: UseFormReturn<WorkspaceCreateValues>;
}) {
  const { t } = useTranslation('workspaces');
  const {
    register,
    watch,
    formState: { errors },
  } = form;
  return (
    <fieldset className="space-y-4">
      <label className="text-ink flex min-h-11 items-center gap-3 text-sm">
        <input
          type="checkbox"
          className="accent-forest size-5"
          {...register('inviteAdmin')}
          aria-describedby="invite-admin-hint"
        />
        {t('inviteAdmin')}
      </label>
      <p id="invite-admin-hint" className="text-ink-soft text-sm">
        {t('inviteAdminHint')}
      </p>
      {watch('inviteAdmin') && (
        <>
          <FormField
            label="E-Mail des ersten Administrators"
            error={errors.adminEmail?.message}
            hint="Erhält die Einladung. Eine E-Mail-Adresse gehört zu genau einem Workspace."
          >
            <Input type="email" autoComplete="off" {...register('adminEmail')} />
          </FormField>
          <div className="grid gap-4 sm:grid-cols-2">
            <FormField label="Vorname" error={errors.adminFirstName?.message}>
              <Input autoComplete="off" {...register('adminFirstName')} />
            </FormField>
            <FormField label="Nachname" error={errors.adminLastName?.message}>
              <Input autoComplete="off" {...register('adminLastName')} />
            </FormField>
          </div>
        </>
      )}
    </fieldset>
  );
}
